import UploadComponent from '../UploadComponent.vue'

export default [
    {
        path: '/nupload',
        component: UploadComponent,
        name: 'nupload',
    }
]